import { useQuery } from 'react-query'

import { useApiClient } from 'clients/yogi-api'
import type {
  KeyInsightItem,
  KeyInsightsResponse,
} from 'features/trend-detection/types'

interface UseKeyInsightsResult {
  keyInsights: KeyInsightItem[]
  isLoading: boolean
}

/**
 * Fetches the cross-agent high-signal feed shown on the Key Insights sub-tab.
 * Backed by `/agent-center/key-insights`. The endpoint already filters/caps
 * server-side per PROD-2925; this hook is a thin React-Query wrapper.
 */
export function useKeyInsights(
  projectId: string | null | undefined,
): UseKeyInsightsResult {
  const apiClient = useApiClient()
  const { data = [], isLoading } = useQuery<KeyInsightItem[]>({
    queryKey: ['agent-center-key-insights', projectId],
    queryFn: async () => {
      if (!projectId) return []
      const { data: response } = await apiClient.get(
        `/agent-center/key-insights?proj_uuid=${projectId}`,
      )
      return (response as KeyInsightsResponse).items
    },
    enabled: !!projectId,
    refetchOnWindowFocus: false,
    staleTime: 60000,
  })
  return { keyInsights: data, isLoading }
}
